import { Injectable } from "@angular/core";
import { HttpClientService } from "@/providers/services/http-client.service";
import { AtualizarPosicaoGpsRequest, Motorista } from "@/providers/models/motorista";
import { PageDatesRequest } from "@/providers/models/pageDatesRequest";

@Injectable({
  providedIn: 'root'
})

export class DriverService {
  constructor(private httpClient: HttpClientService) { }

  async getMotoristas(): Promise<Motorista[]>{
    return this.httpClient.get('/Motorista', '');
  }

  async getMotoristaPorId(motoristaId: number): Promise<Motorista>{
    return this.httpClient.get('/Motorista', `/${motoristaId}`);
  }

  async getPosicaoMorotista(request: AtualizarPosicaoGpsRequest, motoristaId: number): Promise<boolean> {
    return this.httpClient.post('/Motorista', `/posicao/${motoristaId}`, request);
  }
}
